import { z } from "zod"

export const REFERRAL_CODE_LENGTH = 8

/** Shared by the creation form and server action; blank means generate a code. */
export const OptionalPromoCodeSchema = z.string().trim().toLowerCase()
  .refine(value => value === "" || value.length === REFERRAL_CODE_LENGTH, {
    message: `Promo code must be exactly ${REFERRAL_CODE_LENGTH} characters.`,
    params: {reason: "code_length"},
  })
  .refine(value => value === "" || /^[a-z0-9]+$/.test(value), {
    message: "Use only letters and numbers for the promo code.",
    params: {reason: "code_characters"},
  })
  .optional()
  .transform(value => value || undefined)
